// extracted by mini-css-extract-plugin
module.exports = {"container":"additional-module--container--2KxuW"};